import script from "./lista-cadencia.vue?vue&type=script&setup=true&lang=js"
export * from "./lista-cadencia.vue?vue&type=script&setup=true&lang=js"

import "./lista-cadencia.vue?vue&type=style&index=0&id=6227fba2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6227fba2"]])

export default __exports__